import { DateParser } from '@internetarchive/field-parsers';
import { MetadataField } from '../metadata-field';
export class DateField extends MetadataField {
    constructor(rawValue) {
        super(DateParser.shared, rawValue);
    }
}
//# sourceMappingURL=date.js.map